import { Component, Vue } from 'vue-property-decorator'
import { querySummaryStudent, querySummaryClass, editClassStudent } from '@/api'
import urlBase from '@/utils/urlBase'

@Component({ name: 'classStudent-list-page' })
export default class ClassStudentListPage extends Vue {
  private dataType = 1
  private tableAll: any = {}
  private tableData = []
  private classList = []
  private multipleSelection: any = []
  private totalPage = 1;
  private currentPage = 1;
  private adjustmentStudentsDialog: any = false
  private classId: any = ''
  private className: any = ''
  private newClassId: any = ''
  private tableloading: any = false
  private time: any = null
  created () {
    this.initPageData()
  }

  private getRowKeys (row: any) {
    return row.studentId
  }

  private async initPageData () {
    this.classId = this.$route.query.id
    this.className = this.$route.query.className
    if (!this.classId || !this.className) return
    this.tableloading = true
    const param: any = { courseType: this.dataType, id: this.classId, page: this.currentPage, limit: 20 }
    const result: any = await querySummaryStudent(param)
    this.tableAll = result
    this.currentPage = result.currentPage
    this.totalPage = result.allPage
    this.tableData = result.studentList
    this.tableloading = false
    const result1: any = await querySummaryClass({ classId: this.classId })
    this.classList = result1
  }

  private async onPageChange (page: any) {
    this.currentPage = page
    this.initPageData()
  }

  private async onSetClick () {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      const list = this.multipleSelection.map((item: any) => { return item.sellOrderId })
      const { error }: any = await editClassStudent({ oldClassId: this.classId, newClassId: this.newClassId, sellOrderIds: list })
      if (!error) {
        this.$message({ message: '分配学生成功', type: 'success' })
        await this.initPageData()
        this.adjustmentStudentsDialog = false
      }
    }, 300)
  }

  private rowClicked (row: any) {
    this.$router.push({ path: '/student/detail', query: { id: row.studentId, detailType: '1' } })
  }

  private handleClose (tag: any) {
    const multipleTable: any = this.$refs.multipleTable
    this.multipleSelection.splice(this.multipleSelection.indexOf(tag), 1)
    multipleTable.toggleRowSelection(tag, false)
  }

  private handleSelectionChange (val: any) {
    this.multipleSelection = val
  }

  private async exportstudent () {
    // const url = 'http://192.168.0.33:10069/classAdmin/classStudent/export?classId=' + this.classId
    const url = urlBase.eduBaseUrl + 'classAdmin/classStudent/export?classId=' + this.classId
    const a: any = document.createElement('a')
    a.href = url
    a.click()
    this.$message({ message: '导出学生成功', type: 'success' })
  }
}
